module.exports = __webpack_public_path__ + "images/category_lp/watch/headline_ceeab6cc99e3a5bba86e882e0438194e.png";